import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import logo from "../../../assets/images/logo.png";


const WoPrint = () => {
    const navigate = useNavigate();
    const [wo, setwo] = useState(null);
    const params = useParams()



    useEffect(() => {

        if (params?.work_order_id) {
            getwo();

        }


    }, []);



    const getwo = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-wo-print-by-work-order-id/" + params?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setwo(response?.data?.wo)



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });

                }

            }).catch(function (error) {

                catchError(error, navigate)


            });


    }


    return (
        <>
            {wo &&
                <>
                    <table style={{ marginTop: "30px", fontSize: "16px", fontFamily: "'Courier New', 'Lucida Console', monospace" }} width="700px" cellpadding="0" cellspacing="0" align="center" className=" watermarked" >
                       
                       <tr>
                           <td style={{fontWeight:"bold",fontSize:"13px",paddingBottom:"25px"}} colspan="2" >
                           <img src={logo} width="200" border="0" />
                               <br/>
                       
                               POST OFFICE BOX 2191<br/>
                               SAN LEANDRO, CA 94577<br/>
                               PHONE: {process.env.REACT_APP_SUPPORT_PHONE_NUMBER}  EMAIL: Records@MedRecAps.Com<br/>
        SECURE FAX: {process.env.REACT_APP_TOLL_FREE_SUPPORT_FAX} AND {process.env.REACT_APP_SUPPORT_FAX}<br/>
                           </td>
                           <td align="right" style={{paddingBottom:"10px",fontWeight: "bold"}} >
        CASE #: {wo.work_order_no}
    </td>
                       
                       </tr>
                        <tr>
                            <td style={{ textAlign: "center", paddingBottom: "35px" }} colspan="3" >
                                <b><u>Certificate of No Records</u></b>
                            </td>

                        </tr>
                        <tr>
                            <td style={{ paddingBottom: "20px", }} colspan="3" >
                                This is to certify that as the duly authorized custodian of records for:
                            </td>

                        </tr>



                        <tr>
                            <td colspan="3" style={{ paddingBottom: "20px",fontSize:"14px" }} >
                                <b>Facility Information: </b><br />
                                <b>Name: </b>{wo.facility_name } <b style={{marginLeft:"25px"}}>Attn:</b> {wo.facility_attn }<br />

                                <b>Address: </b>{wo.facility_address + ", "}{wo.facility_city + ", "}{wo.facility_state + " "}{wo.facility_zip}<br />
                                {wo.facility_phone &&
                                    <>
                                        <b>Phone:</b> {wo.facility_phone}
                                    </>
                                }

                                {wo.facility_fax &&
                                    <>
                                        <b> Fax:</b> {wo.facility_fax}
                                    </>
                                }
                                <br />
                            </td>
                        </tr>

                        <tr>
                            <td style={{ paddingBottom: "20px" }} colspan="3" >
                                Upon Conducting a diligent search of our medical records for:
                            </td>

                        </tr>

                        <tr>
                            <td colspan="3" style={{ paddingBottom: "20px",fontSize:"14px"  }} >

                                <table>

                                    <tr>
                                        <td align="right" width="120px"  ><b>Name:</b></td>
                                        <td  >
                                            {wo.patient_last_name.toUpperCase() + ", " + wo.patient_first_name?.toUpperCase() + " " + wo.patient_middle_name.toUpperCase()}<br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right" width="120px"  ><b>Date of Birth:</b></td>
                                        <td  >
                                            {wo.patient_dob ? wo.patient_dob : <i>UNKNOWN</i>}<br />
                                        </td>


                                    </tr>

                                    <tr>
                                        <td align="right" width="120px"  ><b>Soc. Sec. No:</b></td>
                                        <td   >
                                            {wo.patient_ssn ? "***-**-" + wo.patient_ssn.substring(wo.patient_ssn.length - 4) : <i>UNKNOWN</i>}
                                        </td>
                                    </tr>
                                     <tr>
                            <td align="right" width="120px"   ><b>Admit Date:</b></td>
                            <td style={{textTransform:"uppercase",}} >{wo.wo_admit_date}</td>
                        </tr>

                                </table>
                            </td>
                        </tr>

                       

                        <tr>
                            <td colspan="3" style={{ fontSize: "14px", paddingBottom: "20px" }} >
                                <ul style={{ marginLeft: "20px" }}>

                                    <li>The search has revealed that no records, documents, or other materials responsive to the request exist within our possession or control with Information Provided.</li>
                                    <li>This search does not mean records Do Not exist under another Name, Spelling or Classification.</li>
                                    <li>This search was conducted in accordance with our standard record-keeping procedures.</li>
                                    <li>All relevant files and databases were searched in accordance with our retention policy for said period.</li>

                                </ul>
                            </td>
                        </tr>




                        <tr>
                            <td colspan="3" style={{ paddingBottom: "35px" }}  ><br />Sincerely,<br /></td>

                        </tr>


                        <tr>
                            <td width="320" style={{ paddingBottom: "35px", borderTop: "2px solid #000" }}  >
                                <b>Signature</b>
                            </td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr>
                            <td width="320" style={{ paddingBottom: "35px", borderTop: "2px solid #000" }}  >
                                <b>Print Name</b>
                            </td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr>
                            <td width="320" style={{ paddingBottom: "35px", borderTop: "2px solid #000" }}  >
                                <b>Title</b>
                            </td>
                            <td></td>
                            <td width="320" style={{ paddingBottom: "35px", borderTop: "2px solid #000" }}  >
                                <b>Date</b>
                            </td>

                        </tr>
                    </table>
                </>

            }
          
        </>
    )

}
export default WoPrint;